import React from 'react';
import './Footer.css'

const Footer = () => {
  return (
    <footer>
      {/* Copyright */}
      <div className="copyright">
        <p>&copy; 2023 Created By <span>Vuyolwethu</span> | All Right Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;